import {Route} from '@angular/router';
import {canAuthGuard} from '@shared/guards/can-auth-guard';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';

export const ACCOUNT_ROUTE: Route = {
  path: EEndpointApp.Account,
  title: 'account',
  canActivate: [canAuthGuard],
  children: [
    {
      path: EEndpointApp.Profile,
      title: 'edit_profile',
      loadComponent: () => import('./profile/profile.component').then((m) => m.ProfileComponent),
    },
    {
      path: EEndpointApp.Security,
      title: 'security',
      loadComponent: () => import('./security/security.component').then((m) => m.SecurityComponent),
    },
    {
      path: EEndpointApp.AuthorizedDevices,
      title: 'authorized_devices',
      loadComponent: () => import('./authorized-devices/authorized-devices.component').then((m) => m.AuthorizedDevicesComponent),
    },
    {
      path: '',
      redirectTo: EEndpointApp.Profile,
      pathMatch: 'prefix',
    },
  ],
};
